window.StockCubeCore = window.StockCubeCore || {};

window.StockCubeCore.formatNumber = function (num) {
    if (num >= 1e9) return (num / 1e9).toFixed(1) + 'B';
    if (num >= 1e6) return (num / 1e6).toFixed(1) + 'M';
    if (num >= 1e3) return (num / 1e3).toFixed(1) + 'K';
    return num.toFixed(0);
};

window.StockCubeCore.parseCapToAbsolute = function (value) {
    if (value === null || typeof value === 'undefined') return null;
    if (typeof value === 'string') {
        const trimmed = value.trim();
        const match = trimmed.match(/^([0-9]+(?:\.[0-9]+)?)\s*([kKmMbB])?$/);
        if (match) {
            const num = parseFloat(match[1]);
            const suffix = match[2] ? match[2].toUpperCase() : '';
            const mult = suffix === 'K' ? 1e3 : suffix === 'M' ? 1e6 : suffix === 'B' ? 1e9 : 1;
            return num * mult;
        }
        const asNum = Number(trimmed);
        if (!isNaN(asNum)) {
            return asNum < 1e6 && asNum > 0 ? asNum * 1e6 : asNum;
        }
        return null;
    }
    if (typeof value === 'number') {
        if (!isFinite(value) || value <= 0) return null;
        return value < 1e6 ? value * 1e6 : value;
    }
    return null;
};

window.StockCubeCore.correctToZero = function (value, threshold = 0.000001) {
    return Math.abs(value) < threshold ? 0 : value;
};

window.StockCubeCore.parseVector3Attr = function (value) {
    if (!value) {
        return { x: 0, y: 0, z: 0 };
    }
    if (typeof value === 'string') {
        const parts = value.split(' ').map(parseFloat);
        return {
            x: Number.isFinite(parts[0]) ? parts[0] : 0,
            y: Number.isFinite(parts[1]) ? parts[1] : 0,
            z: Number.isFinite(parts[2]) ? parts[2] : 0
        };
    }
    return {
        x: Number.isFinite(value.x) ? value.x : 0,
        y: Number.isFinite(value.y) ? value.y : 0,
        z: Number.isFinite(value.z) ? value.z : 0
    };
};
